import dayjs from "dayjs";
import { Intermediary } from "../../interfaces";
import { GetClientBalanceListServiceResponse } from "../../interfaces/services/client-balance";
import { GetWithholdingDetailFilter, GetWithholdingDetailListServiceResponse, PostDownloadWithholdingDetailResponse, Withholding } from "../../interfaces/services/withholding-detail";
import { getError, getUserInfo } from "../../utils";
import userHelper from "../../utils/userHelper";
import CustomHttpClient from "../customHttpClient";
import { AxiosResponse } from "axios";

const customHttpClient = CustomHttpClient({
    baseUrl: 'productores',
});

const CurrentAccountService = {

    async getClientBalance( intermediary: Intermediary | undefined): Promise<GetClientBalanceListServiceResponse> {
        const url = 'saldoDeCuentaCorriente';
        
        try {                        
            const params = {
                numeroMayorAuxiliar: intermediary!.nroMayorAux,
                codigoMayorAuxiliar: intermediary!.codMayorAux,
                ...getUserInfo(),
            }
            
            
            const response = await customHttpClient.get(url, { params });
            
            let clientBalance = response.data;

            return clientBalance;
        }catch(error){            
            throw new Error(getError(error));
        }
    },

    async getWithholdingDetail( filters: GetWithholdingDetailFilter, intermediary : Intermediary ): Promise<GetWithholdingDetailListServiceResponse> {
        const url = 'detalleDeRetenciones';
        const formattedDates = filters.date.map((date) => dayjs(date).format('YYYY-MM-DD'));
        
        try {
            const user = userHelper.getUser();
            const params = {
                empresa: user?.codigoDeEmpresa,
                sucursal: user?.codigoDeSucursal,
                numeroMayorAuxiliar: intermediary?.nroMayorAux,
                codigoMayorAuxiliar: intermediary?.codMayorAux,
                fechaDesde: formattedDates[0],
                fechaHasta: formattedDates[1],
            };
            
            const response = await customHttpClient.get(url, {params});
            
            let withholdingDetail = response.data;

            return withholdingDetail;
        }catch(error){            
            throw new Error(getError(error));
        }
    },

      async postDownloadWiholdingDetailsFiles(certificates: Array<Withholding>, intermediary : Intermediary ): Promise<Array<PostDownloadWithholdingDetailResponse>> {
        const url = 'descargaCertificadosRetencion';

        const withholdingcertificatesRequest = certificates.map(cert => ({
            ...cert,
            codMayorAux: intermediary.codMayorAux,
            nroMayorAux: intermediary.nroMayorAux
        }));

        try {
          const response = await customHttpClient.post<Array<PostDownloadWithholdingDetailResponse>>(url, withholdingcertificatesRequest);
    
          return response.data;
        } catch (error) {
          throw new Error(getError(error));
        }
      },
}
export default CurrentAccountService;